exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "td[data-v-24a251cf],th[data-v-24a251cf]{width:200px}tbody tr[data-v-24a251cf]{cursor:pointer}", ""]);

// exports
